import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Prevent scrolling when menu is open
    document.body.style.overflow = !isMenuOpen ? 'hidden' : 'auto';
  };

  return (
    <header className="site-header">
      <nav className="nav-container">
        <Link
          to="/"
          className="nav-logo"
          aria-label="LeapYear home"
          onClick={() => isMenuOpen && toggleMenu()}
        >
          LY
        </Link>
        
        <div className="desktop-menu">
          <div className="menu-links">
            <Link to="/investments">ALUMNI</Link>
            <Link to="/people">PEOPLE</Link>
            <Link to="/investors">INVESTORS</Link>
            <Link to="/faq">FAQ</Link>
          </div>
        </div>

        <Link
          to="/apply"
          className="nav-apply"
          onClick={() => isMenuOpen && toggleMenu()}
        >
          APPLY
        </Link>

        <div 
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span style={{ width: '1.0rem', marginLeft: '1.0rem' }}></span>
          <span></span>
        </div>

        <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
          <div className="menu-links">
            <Link to="/" onClick={toggleMenu}>HOME</Link>
            <Link to="/apply" onClick={toggleMenu}>APPLY</Link>
            <Link to="/investments" onClick={toggleMenu}>ALUMNI</Link>
            <Link to="/people" onClick={toggleMenu}>PEOPLE</Link>
            <Link to="/investors" onClick={toggleMenu}>INVESTORS</Link>
            <Link to="/faq" onClick={toggleMenu}>FAQ</Link>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;